import { action, props } from 'ts-action';
import { SkipHistory } from '../../undo/actions/undo.actions';

export const stop = action('[Episode measurement] stop');

export const setBoundary = action(
  '[Episode measurement] setBoundary',
  props<{ boundary: 'start' | 'end'; timestamp?: number }>(),
);

export const setMoving = action(
  '[Episode measurement] setMoving',
  props<{ timestamp: number }>(),
);

export const setTimestamp = action(
  '[Episode measurement] setTimestamp',
  props<{ timestamp: number } & SkipHistory>(),
);

export const setRange = action(
  '[Episode measurement] setRange',
  props<{ start: number; end: number } & SkipHistory>(),
);
